/* @jsx h */
import { defineComponent, h } from "vue";

export const formatDelta = (current: number, previous: number) => {
  if (previous === 0) {
    if (current === 0) {
      return { value: 0, positive: true };
    }
    return { value: 100, positive: true };
  }

  const raw = ((current - previous) / Math.abs(previous)) * 100;
  return {
    value: Math.abs(raw),
    positive: raw >= 0,
  };
};

export const AdminMetricCard = defineComponent({
  name: "AdminMetricCard",
  props: ["title", "value", "subtitle", "icon", "current", "previous"],
  setup(props) {
    return () => {
      const delta = formatDelta(
        Number(props.current || 0),
        Number(props.previous || 0),
      );
      return (
        <div class="rounded-2xl border border-base-300/60 bg-base-100 p-5 shadow-sm">
          <div class="mb-3 flex items-start justify-between gap-3">
            <div>
              <div class="text-sm font-medium uppercase tracking-wide text-accent/80">
                {props.title}
              </div>
              <div class="mt-2 text-3xl font-semibold text-accent">
                {props.value}
              </div>
            </div>
            <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-accent/10 text-accent">
              <span class="material-symbols-outlined">{props.icon}</span>
            </div>
          </div>
          <div class="flex items-center justify-between gap-3 text-sm">
            <span class={delta.positive ? "text-success" : "text-error"}>
              {delta.positive ? "+" : "-"}
              {delta.value.toFixed(1)}%
            </span>
            <span class="text-base-content/60">{props.subtitle}</span>
          </div>
        </div>
      );
    };
  },
});
